import React, { useEffect } from 'react'
import { useAuth } from 'wasp/client/auth'
import { useNavigate } from 'react-router-dom'
// AppFrame removed: route-level layout wraps admin pages
import { Card } from '../../components/ui/card'

export function AdminPlans() {
  const { data: user } = useAuth()
  const navigate = useNavigate()
  useEffect(() => { if (user && !(user as any).isAdmin) navigate('/') }, [user])
  return (
      <div className="space-y-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Plan Management</h1>
          <p className="text-gray-600">Meal plan analytics and curation tools</p>
        </div>
        
        <Card className="p-6">
          <div className="text-lg font-medium text-gray-900 mb-4">Coming Soon</div>
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-gray-700">Plan metrics and curation tools are in development.</p>
          </div>
        </Card>
      </div>
  )
}

export default AdminPlans
